import React from 'react'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { Platform } from 'react-native'
import All from './components/All'
import My from './components/My'
import MainContainer from '../../navigation/layouts/Main/MainContainer'
import TopTabBarNavigation from '../../navigation/layouts/Main/TopTabBarNavigation'

import { useTheme } from '../../theming/ThemeProvider'

const Tab = createMaterialTopTabNavigator()

const Loads = () => {
  const { theme } = useTheme()

  return (
    <MainContainer title='My loads'>
      <Tab.Navigator
        tabBar={props => <TopTabBarNavigation {...props} />}
        sceneContainerStyle={{
          backgroundColor: theme.WHITE
        }}
        swipeEnabled={Platform.OS !== 'web'}
      >
        <Tab.Screen name='all' component={All} options={{ tabBarLabel: 'All Available Loads' }} />
        <Tab.Screen name='my' component={My} options={{ tabBarLabel: 'My Available Loads' }} />
      </Tab.Navigator>
    </MainContainer>
  )
}

export default Loads
